import {
    BaseQueryFn,
    createApi,
    FetchArgs,
    fetchBaseQuery,
    FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";

export const dynamicBaseQuery: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
    const mainApiUrl = "http://localhost:5000/api";
    const rawBaseQuery = fetchBaseQuery({
        baseUrl: mainApiUrl,
        prepareHeaders: headers => {
            return headers;
        },
    });

    return rawBaseQuery(args, api, extraOptions);
};

export const localApi = createApi({
    reducerPath: "localApi",
    baseQuery: dynamicBaseQuery,
    endpoints: () => ({}),
});

const extendedApi = localApi.injectEndpoints({
    endpoints: builder => ({
        localGetRealPropertyDetails: builder.query<any, any>({
            query: (request: any) => ({
                url: "getRealProperty",
                body: request,
                method: "POST",
            }),
        }),
    }),
    overrideExisting: false,
});

export const { useLocalGetRealPropertyDetailsQuery } = extendedApi;
